/**
 * @description Directory for ID Attributes on Password Change.
 * Naming Convention: "data-test-id-[VIEW/COMPONENT]-[ELEMENT]-[NAME]".
 * Example: id = "data-test-id-mainlayout-btn-cancel".
 */
const idDirectory = {
    alertPolicy: `passwordChange-alert-policy`,
    btnChangePwd: `passwordChange-btn-changePwd`,
 
}

export default idDirectory
